<template>
  <v-container class="padding-table">
    <div class="card-table">
      <div class="table-warpper pa-5">
        <div class="title-warpper mb-5">
          <div class="count" v-if="!mobile">
            <v-chip class="ma-2">{{ countTotal }} รายการ</v-chip>
          </div>
          <div class="btn header-border" v-if="!mobile">Detail Log</div>
          <div v-if="mobile" class="d-flex col-12 justify-space-between">
            <v-chip class="ma-2">{{ countTotal }} รายการ</v-chip>
            <div class="btn header-border d-flex align-self-center">Detail Log</div>
          </div>
          <v-spacer v-if="!mobile"></v-spacer>
          <transition name="fade">
            <v-row>
              <v-col md="6" offset-md="6">
                <v-text-field v-model="searchTable" append-icon="mdi-magnify" label="Search" style="border-radius: 22px;" dense outlined color="green lighten-1"></v-text-field>
              </v-col>
            </v-row>
          </transition>
        </div>
        <transition name="fade">
          <v-data-table 
            :headers="headers" 
            :items="detailDataTables" 
            :items-per-page="5" 
            :search="searchTable" 
            class="elevation-1 v-table overflow-y-auto" 
            :loading="loadingVTable" 
            mobile-breakpoint="0" 
            loading-text="Loading... Please wait">
            <template v-slot:[`item.no`]="{ index }">
              <div>{{index + 1}}</div>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <v-chip
                :class="item.status.toLowerCase() === 'success' ? 'ma-2 btn-success' : 'ma-2 btn-err'">
                {{item.status.toLowerCase() === 'success'? 'Success' : 'Fail'}}
              </v-chip>
            </template>
          </v-data-table>
        </transition>
      </div>
    </div>
  </v-container>
</template>

<script>
import listdata from '../../assets/json/ListDetailLog.json'
export default {
  name: "DetailLogTableComponent",
  data: () => ({
    countTotal: 0,
    searchTable: '',
    headers: [
      { text: "No", value: "no", align: "center", width: "100", sortable: true, class: "pl-7" },
      { text: "Date/Time", value: "dateTime", align: "center", width: "200", sort:  (a,b)=> {
          let convertDate = (date)=> {
            return new Date(date.split(`/`).reverse().join(`/`));
          }
          const dateA = convertDate(a).getTime();
          const dateB = convertDate(b).getTime();
          return dateA > dateB ? 1 : -1;  
        }
      },
      { text: "Type", value: "type", align: "center", width: "150", sortable: true, class: "pl-7" },
      { text: "Status", value: "status", width: "150", sortable: true, align: "center", class: "pl-7" },
      { text: "IP", value: "ip", align: "center", width: "150", sortable: true, },
      { text: "Method", value: "method", sortable: true, align: "center", width: "200", class: "pl-7" },
      { text: "Note", value: "note", align: "center", sortable: false, width: "300"}
    ],
    detailDataTables: [],
    mobile:window.innerWidth <= 959,
    loadingVTable: false
  }),
  mounted() {
    this.loadingVTable = true; 
    this.getDataList();
    this.loadingVTable = false;
  },
  created() {
    addEventListener('resize', () => {
      this.mobile = innerWidth <= 959
    })
  },
  methods: {
    async getDataList() {
      this.detailDataTables = []
      this.countTotal = 0
      // console.log('listdata',listdata)
      const res = listdata
      if (res.statusCode === '200') {
        this.detailDataTables = res.data
        this.countTotal = this.detailDataTables.length
      }
    }
  }
}
</script>

<style scoped>
.padding-table {
  padding: 7rem;
  padding-top: 9rem;
}
.card-table {
  display: flex;
  /* height: 268px; */
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 5px 15px 0 #959494 !important;
  background-color: #ffffff;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.title-warpper {
  display: flex;
  align-items: center;
  width: 100%;
}

.table-warpper {
  width: 100%;
}
.header-border {
  padding: 5px 20px;
  border-radius: 2rem;
  background: #7EC241;
  color: #fff !important;
  border: 0;
  font-size: 16px;
  text-transform: uppercase;
  -webkit-box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  cursor: initial !important;
}
.v-table {
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
  background-color: #ffffff;
}
.v-table ::v-deep th {
  font-size: 14px !important;
}
.btn-err {
  background-color: #F44336 !important;
  color: white !important
}
.btn-success {
  background-color: #75bb37 !important;
  color: white !important
}
@media screen and (max-width: 959px) {
  /* .card-table {
    box-shadow: none !important;
  } */
  .padding-table {
    padding: 1rem;
    padding-top: 7rem;
  }
  .v-table {
    border-radius: 8px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
    background-color: #ffffff;
  }
  .v-table ::v-deep .v-data-footer {
    justify-content: end;
  }
  .title-warpper {
    display: block;
  }
}
</style>